<div
  class="w-full rounded-2xl bg-linear-(--my-gradient1) border-[#D9D9D9] shadow-(--my-shadow) pt-8 lg:pt-15 px-2 lg:px-5 mb-4 mb-md-0">

  <!-- HEADER -->
  <p
    class="text-white font-bold text-xl md:text-2xl lg:text-4xl xl:text-[45px] capitalize text-center mb-1">
    Welcome,
  </p>
  <p
    class="text-white font-normal text-lg md:text-xl lg:text-2xl xl:text-3xl text-center">
    Verify OTP & Reset Password
  </p>

  <div class="bg-white mt-6 lg:mt-10 w-full rounded-xl">
    <div
      class="p-4 md:py-8 md:px-10 xl:py-10 xl:px-20 rounded-xl bg-white">
      <form [formGroup]="forgotPasswordForm" (ngSubmit)="verifyOtp()">
        <!-- OTP SECTION -->
        <p class="text-444 font-bold text-base md:text-xl xl:text-2xl mb-2 lg:mb-4">
          Check Your Email
        </p>
        <p
          class="text-sm lg:text-base text-[#898989] mb-6">
          We sent a reset code to
          <span class="text-[#2563eb] font-medium">
            {{ emailFromState }}
          </span>. Enter the 6-digit code below:
        </p>

        <!-- OTP INPUT BOXES -->
        <div class="relative mb-6">
          <div
            class="flex items-center justify-between gap-2 max-w-md mx-auto">
            <input type="text" maxlength="1" formControlName="d1" (keyup)="handleOtpInput($event, 0)" #otpInput
              class="block text-center px-1 py-3 size-11 xl:size-13 text-lg text-444 font-bold bg-transparent rounded-lg border-2 border-[#d9d9d9] focus:border-c19725 focus:outline-none" />
            <input type="text" maxlength="1" formControlName="d2" (keyup)="handleOtpInput($event, 1)" #otpInput
              class="block text-center px-1 py-3 size-11 xl:size-13 text-lg text-444 font-bold bg-transparent rounded-lg border-2 border-[#d9d9d9] focus:border-c19725 focus:outline-none" />
            <input type="text" maxlength="1" formControlName="d3" (keyup)="handleOtpInput($event, 2)" #otpInput
              class="block text-center px-1 py-3 size-11 xl:size-13 text-lg text-444 font-bold bg-transparent rounded-lg border-2 border-[#d9d9d9] focus:border-c19725 focus:outline-none" />
            <input type="text" maxlength="1" formControlName="d4" (keyup)="handleOtpInput($event, 3)" #otpInput
              class="block text-center px-1 py-3 size-11 xl:size-13 text-lg text-444 font-bold bg-transparent rounded-lg border-2 border-[#d9d9d9] focus:border-c19725 focus:outline-none" />
            <input type="text" maxlength="1" formControlName="d5" (keyup)="handleOtpInput($event, 4)" #otpInput
              class="block text-center px-1 py-3 size-11 xl:size-13 text-lg text-444 font-bold bg-transparent rounded-lg border-2 border-[#d9d9d9] focus:border-c19725 focus:outline-none" />
            <input type="text" maxlength="1" formControlName="d6" (keyup)="handleOtpInput($event, 5)" #otpInput
              class="block text-center px-1 py-3 size-11 xl:size-13 text-lg text-444 font-bold bg-transparent rounded-lg border-2 border-[#d9d9d9] focus:border-c19725 focus:outline-none" />
          </div>
        </div>

        <!-- PASSWORD SECTION -->
        <div class="border-t border-[#eee] pt-6 mt-6">
          <p
            class="text-444 font-bold text-base md:text-xl xl:text-2xl mb-2 lg:mb-4">
            Set New Password
          </p>
          <p
            class="text-sm lg:text-base text-[#898989] mb-6">
            Create a new password for your account.
          </p>

          <!-- PASSWORD INPUT -->
          <div class="relative mb-6">
            <input type="password" id="password" formControlName="password"
              class="block px-2.5 pb-3 pt-3 w-full text-sm lg:text-base text-444 font-normal bg-transparent rounded-lg border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="password"
              class="absolute text-sm lg:text-base text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">
              New Password
            </label>
            <div *ngIf="forgotPasswordForm.get('password')?.touched && forgotPasswordForm.get('password')?.invalid" class="text-red-500 text-sm mt-1">
              <span *ngIf="forgotPasswordForm.get('password')?.errors?.['required']">*Password is required</span>
              <span *ngIf="forgotPasswordForm.get('password')?.errors?.['minlength']">*Password must be at least 6 characters</span>
            </div>
          </div>

          <!-- CONFIRM PASSWORD INPUT -->
          <div class="relative mb-6">
            <input type="password" id="password_confirmation" formControlName="password_confirmation"
              class="block px-2.5 pb-3 pt-3 w-full text-sm lg:text-base text-444 font-normal bg-transparent rounded-lg border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="password_confirmation"
              class="absolute text-sm lg:text-base text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">
              Confirm New Password
            </label>
          </div>
        </div>

        <!-- UPDATE PASSWORD BUTTON -->
        <div class="flex items-center justify-center mt-6">
          <button type="submit" [disabled]="isLoading"
            class="flex items-center justify-center cursor-pointer px-5 md:px-7 lg:px-10 w-[150px] lg:w-[300px] py-2 lg:py-3.5 text-base md:text-lg lg:text-2xl font-bold text-white bg-c19725 border-2 border-c19725 hover:bg-[#fdffc6] hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-lg text-center disabled:opacity-70 disabled:cursor-not-allowed">
            <ng-container *ngIf="!isLoading; else loadingUpdate">Update Password</ng-container>
            <ng-template #loadingUpdate>
              <i class="fas fa-spinner fa-spin mr-2"></i> Updating...
            </ng-template>
          </button>
        </div>

        <p
          class="font-normal text-sm lg:text-lg text-center mt-6 text-[#898989]">
          Haven’t got the email yet?
          <button type="button" (click)="resendOtp()" [disabled]="isResending"
            class="underline underline-offset-2 mx-1 font-bold text-c19725 hover:text-b08720 cursor-pointer disabled:opacity-50">
            <span *ngIf="!isResending">Resend code</span>
            <span *ngIf="isResending"><i class="fas fa-spinner fa-spin mr-1"></i> Resending...</span>
          </button>
        </p>

        <p class="font-normal text-sm lg:text-base text-center mt-3 text-c19725">
          <a routerLink="/login" class="hover:underline">Back to Login</a>
        </p>

      </form>
    </div>
  </div>
</div>

